import React, { forwardRef, useState, useEffect } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";
import { getImagePath } from "../../utilities/path";
import { AutomationTestIdFeature, AutomationTestIdElementType, createDataTestId } from "../../utilities/automation";
import Picture from "../Picture";

export interface IImageColumnProps extends IEditableProps, IStyledProps {
    src: string;
    alt: string;
    className;
    square: boolean;
    children;
    widgetType;
}

const ImageColumn = forwardRef((props: IImageColumnProps, ref: any) => {
    const { children, className, editorClassObj, cmsId } = props;
    const [classState, setClassState] = useState([]);

    useEffect(() => {
        setClassState(!props.square ? [
            "py-md-4",
            "px-md-4",
            "col-md"
        ] : [
            "col-lg",
            "col-sm-6",
            "col-12"
        ]);
    }, [props.square]);

    const overlay = React.Children.map(children, child => {
        if (typeof child === "object") {
            const { className = "" } = child;

            const classes = !props.square ? [
                "flex-50",
                "h-md-100",
                "mh-50",
                "p-4"
            ] : [
                "h-100",
                "w-100"
            ];

            const headerClasses = props.square ? [
                "text-sans"
            ] : []

            return React.cloneElement(child, { className: classNames(className, classes), headerClassName: classNames(headerClasses) })
        }
        return child;
    });

    return (
        <div data-id={cmsId} ref={ref}
            className={classNames("d-flex flex-column justify-content-end image-column px-0", className, editorClassObj, classState)}>
            <Picture
                loading="lazy"
                src={getImagePath(props.src)}
                alt={props.alt}
                dataTestId={createDataTestId({feature: AutomationTestIdFeature.IMAGE_COLUMN, element: AutomationTestIdElementType.IMAGE})}
            />
            {overlay}
        </div>
    )
});

export default styled(ImageColumn)<{ square: boolean }>`
    min-height: 350px;
    background-color: #e0e0e0;
    position: relative;
    overflow: hidden;

    @media (min-width: 768px) {
        height: ${props => props.square ? "350px" : "645px"};
    }

    @media (max-width: 768px) {
        .overlay {
            height: 100%;
            padding: 2rem 1.5rem !important;
        }
    }

    &:nth-child(even) {
        background-color: #f1f1f1;
    }

    img {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        block-size: auto;
        min-width: 100%;
    }

    ${props => props.square ? `
        .overlay {
            padding: 2rem;
        }
    ` : ""}
`;